/**
 * Versão runtime do SDK. Fonte de verdade: `packages/pixel/package.json`.
 * Não importe `package.json` neste módulo (bundle browser).
 */
export const SDK_VERSION = '0.1.0-rc.22';
